<template>
  <!-- FOOTER -->
  <div class="mt-auto flex flex-col">
    <div
      class="px-6 py-4 border-t border-slate-700 bg-slate-800 flex items-center gap-3 justify-between hover:bg-slate-700 transition-colors duration-150">

      <!-- User Info -->
      <div class="flex items-center gap-3 overflow-hidden">
        <img :src="user.userProfile" alt="User Avatar"
          class="w-10 h-10 rounded-full object-cover border-2 border-gray-500" />
        <div class="flex flex-col overflow-hidden">
          <p class="text-white font-semibold truncate text-sm" :title="user.name">
            {{ user.name }}
          </p>
          <p class="text-gray-400 text-xs truncate" :title="`${user} - ${user.department}`">
            {{ user.department }} ( {{ user.gazetteRole }} )

          </p>
        </div>
      </div>

      <!-- Logout Button -->
      <button @click="$emit('logout')" class="text-gray-400 hover:text-red-500 transition-colors duration-150"
        title="Logout">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h6a2 2 0 012 2v1" />
        </svg>
      </button>
    </div>

    <!-- Version at the very bottom -->
    <div class="bg-slate-900 text-gray-400 text-xs text-center py-2 border-t border-slate-700 select-none">
      <span>Version {{ version }}</span>
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "vue";

export default {
  name: "HeroSideBarFooter",
  props: {
    user: { type: Object, required: true },
  },
  setup(props) {

    const version = process.env.VUE_APP_VERSION

    const firstName = computed(() => {
      return props.user.name.split("")[0];
    });

    const capitalize = (str) => {
      return str ? str.charAt(0).toUpperCase() + str.slice(1) : "";
    };

    onMounted(() => {
      console.log(version);
    });

    return {
      version,
      firstName,
      capitalize,
    };
  },
};
</script>